function floatingAds(p_enabledAds, p_banner, p_box_top, p_banner_big, p_mobile_box_top){

    //add the sitename to the body tag to target css on differences between sites
    if( SITE_INFO['name'] && !$('body').hasClass(SITE_INFO['name']) ){
        $('body').addClass(SITE_INFO['name']);
    }

    var getBannerHidePoint = function(){
        
        var $ora = $('#oracontainer');

        if($ora.length == 0 || $ora.height() == 0){
            return 985;
        }

        var top = $ora.offset().top;
        var height = $ora.height();
        
        return top+height;
    }

    // possible to pass these as false to turn off ad transitions
    var enabledAds = {
        banner: true,
        box_top: true,
        big_banner: true,
        mobile_box_top: true,
    };
    p_enabledAds = p_enabledAds || {};
    $.extend(true, enabledAds, p_enabledAds);

    var banner = {
        tag: '.RC-AD-TOP-BANNER',
        cookie: 'rc-ad_rc-ad-top-banner_sticky-banner_close-ad',

        triggerPoint: 10,//point at which ad will become fixed
        hidePoint: getBannerHidePoint(), //point at which ad will slide up and hide

        sticky: 'sticky-banner', //class causes the banner to stick to the top
        slideUp: 'banner-slide-up', //class causese the sticky banner to slide up
        has_tynt: 'has-tynt-ad',
        tynt_class: '.tynt-ad-fence',

        adHidden: false, //flag for big banner to know when to show up
    };
    p_banner = p_banner || {};
    $.extend(true, banner, p_banner);

    var box_top = {
        init: false,//after initial setting up of the DOM, this is true

        tag: '.RC-AD-BOX-TOP',
        beta: '.beta-container .beta',
        beta_top: 0,//will trigger fixPos class once the beta top position is scrolled
        //trigger: 600//how long to make the beta column to be fixed, then it will be absolute positioned
        trigger: 360,//how long to make the beta column to be fixed, then it will be absolute positioned

        adHeight: 0,//needed to so some calculations

        fixPos: 'fix-box-top',//added to beta column to make it fixed so it scrolls with the user
        absPos: 'abs-box-top',//added to beta column after fixed to make it absolute positioned, not used anymore
        relPos: 'rel-box-top',//added to beta column after fixed to make it relative positioned
    };
    p_box_top = p_box_top || {};
    $.extend(true, box_top, p_box_top);

    var rightColPadding = 34;
    if( $('#container').width() == 1280 ){
        rightColPadding = 134;
    }

    var banner_big = {
        init: false,//set to true when initial DOM setup is done

        adWrapper: 'banner-big-wrapper',//wraps banner add with div with this class
        adContainer: '.top-bannerx',//the ad container div
        ad: '.RC-AD-TOP-BANNER-BIG',//the ad div element class

        // these two are calculated on the fly but set with innitial to
        // do the math before the ad is loaded in yet
        adHeight: 90,
        adWidth: 970,

        // this the selector and top position of it
        // where the big banner will be hidden
        hideEl: '#hpstreams',
        hidePoint: 0,
        hasCloser: false,
        rightColPadding: rightColPadding,
    };
    p_banner_big = p_banner_big || {};
    $.extend(true, banner_big, p_banner_big);

    var mobile_box_top = {
        init: false,

        tag: '.RC-AD-BOX-TOP',

        wrapperTag: 'top-ad-wrapper-mobile',
        containerTag: 'top-ad-container-mobile',
        adDiv: 'top-ad-div',

        adEl: null,

        adHeight: 0,
        adWidth: 0,
        adBottom: 0,

        hidePoint: 500,
    };
    p_mobile_box_top = p_mobile_box_top || {};
    $.extend(true, mobile_box_top, p_mobile_box_top);

    return {

        pos:{
            top: 0,
            width: 0,

            gamma_left: 0,
            gamma_right: 0,
            gamma_width: 0,

            alpha_left: 0,
            alpha_width: 0,
            alpha_right: 0,
        },

        enabledAds: enabledAds,

        activeAds: {
            banner: false,
            box_top: false,
            big_banner: false,
            mobile_box_banner: false,
            tynt: false,
        },

        ads:{
            banner: banner,
            box_top: box_top,
            banner_big: banner_big,
            mobile_box_top: mobile_box_top,
            tynt: {
                found: false,
                ora_select: '#oracontainer',
                tynt_select: 'iframe.placement-fixed-footer',
                ora_bot_pos: 0,
                tynt_top_top: 0,
            },
        },

        timeoutID:0,

        /**
         * ENTRY POINT TO START LISTENER AND AD SETTINGS
         */
        init: function(){
            this.updateScrollValues();

            if(this.enabledAds.box_top == true){
                this.initBoxTop();
            }

            if(this.enabledAds.big_banner == true && $(this.ads.banner_big.hideEl).length > 0){
                console.log('initBitBanner');
                this.initBigBanner();
            }

            if(this.enabledAds.mobile_box_top == true){
                this.initMobileBoxTop();
            }

            this.setListeners();
        },

        /**
         * SETS WINDOW LISTENERS FOR SCROLL
         */
        setListeners: function(){

            $( window ).scroll(function(event){

                this.checkForTynt();
                this.scrollBack(event);

            }.bind(this));

            $(window).scroll();
        },

        /**
         * Check if tynt is on the page and set a class on it to transition it
         */
        checkForTynt: function(){

            // placement-fixed-footer spout-mode- spout-show
            if( this.ads.tynt.found == false 
                && $(this.ads.tynt.ora_select).length > 0 
                && $(this.ads.tynt.tynt_select).length > 0 ){
                $(this.ads.tynt.tynt_select).css({'transition': 'transform .25s ease-in-out'});
                this.ads.tynt.found = true;
            }
            
        },

        /**
         * THE SCROLL EVENT TRIGGERS THIS FUNCTION
         * IT HAS A TIMEOUT TO MAKE PERFORMANCE AS BEST AS POSSIBLE
         */
        scrollBack: function(event){

            clearTimeout(this.timeoutID);

            this.timeoutID = setTimeout(function(){
                this.updateScrollValues(event);
                this.parseAdsPositions();
            }.bind(this), 10);
        },

        /**
         * AFTER TIME OUT IN scrollBack() EXPIRES THIS IS TRIGGERED
         * UPDATES DIMENSIONS USED BY ALL AD POSITIONING CALCULATIONS
         */
        updateScrollValues: function(event){

            this.pos.top = window.pageYOffset;
            this.pos.width = window.innerWidth;

            if( $('.gamma').length > 0 ){
                this.pos.gamma_left = $('.gamma').offset().left;
                this.pos.gamma_width = $('.gamma').width();
                this.pos.gamma_right = this.pos.gamma_left + this.pos.gamma_width;
            }

            if( $('.alpha').length > 0 ){
                this.pos.alpha_left = $('.alpha').offset().left;
                this.pos.alpha_width = $('.alpha').width();
                this.pos.alpha_right = this.pos.alpha_left + this.pos.alpha_width;
            }

            if(this.pos.width >= 768 && this.enabledAds.box_top == true){

                this.ads.box_top.adHeight = $('.beta '+this.ads.box_top.tag+' > div').height();
            }

            if(this.pos.width >= 1400 && this.enabledAds.big_banner == true){

                // this.ads.banner_big.adHeight = $(this.ads.banner_big.ad+' > div').height() || 90;
                this.ads.banner_big.adHeight = $(this.ads.banner_big.ad+' > div:nth-child(2)').height() || 90;

                this.ads.banner_big.adWidth = $(this.ads.banner_big.ad+' > div:nth-child(2) ').width() || 970;

                if( $(this.ads.banner_big.hideEl).length > 0 ){
                    this.ads.banner_big.hidePoint = $(this.ads.banner_big.hideEl).offset().top + 225;
                }
            }

            if(this.pos.width < 768 && this.enabledAds.mobile_box_top == true ){

                if(!this.ads.mobile_box_top.adEl || this.ads.mobile_box_top.adEl == null){
                    this.ads.mobile_box_top.adEl = $('div.alpha div'+this.ads.mobile_box_top.tag);
                }

                this.ads.mobile_box_top.adHeight = $(this.ads.mobile_box_top.adEl).height();
                this.ads.mobile_box_top.adWidth = $(this.ads.mobile_box_top.adEl).width();

            }

            if( this.ads.tynt.found == true ){
                this.ads.tynt.ora_bot_pos = $(this.ads.tynt.ora_select).offset().top + $(this.ads.tynt.ora_select).height();
                this.ads.tynt.tynt_top_top = $(this.ads.tynt.tynt_select).offset().top;
            }
        },

        /**
         * AFTER EVERY CALL TO UPDATE SCROLL VALUES THIS IS TRIGGERED
         * RUNS THE FUNCTIONS TO UPDATE THE AD POSITIONING
         */
        parseAdsPositions: function(){

            if(this.pos.width >= 768 && this.enabledAds.box_top == true){
                this.parseBoxTop();
            }

            if(this.pos.width >= 768 && this.enabledAds.banner == true){
                this.parseBannerAd();
            }

            if(this.pos.width >= 1300 && this.enabledAds.big_banner == true){
                this.parseBigBanner();
            }

            if(this.pos.width < 768 && this.enabledAds.mobile_box_top == true){
                this.parseMobileBoxTop();
            }

            if( this.ads.tynt.found == true ){
                this.parseTyntAd();
            }
        },

        /**
         * If above ora video container then hide it
         * Else show it
         */
        parseTyntAd: function(){

            this.activeAds.tynt = true;

            if( (this.ads.tynt.tynt_top_top - 100) <= this.ads.tynt.ora_bot_pos){
                var height = $(this.ads.tynt.tynt_select).height();
                $(this.ads.tynt.tynt_select).css({'transform': 'translateY('+height+'px)'});
            }else{
                $(this.ads.tynt.tynt_select).css({'transform': 'translateY(0px)'});
            }
        },

        /**
         * POSIONS LOCATION OF THE LEADERBOARD BANNER AD
         */
        parseBannerAd: function(){

            if(readCookie(this.ads.banner.cookie)){
                return;
            }

            this.activeAds.banner = true;

            var triggerPoint = this.ads.banner.triggerPoint;

            var tag = this.ads.banner.tag;

            var sticky = this.ads.banner.sticky;
            var slideUp = this.ads.banner.slideUp;

            var hidePoint = this.ads.banner.hidePoint; 

            var has_tynt = this.ads.banner.has_tynt;
            var tynt_class = this.ads.banner.tynt_class;

            var pos = this.pos;

            //if tynt add class that allows the add to move to the top of the page
            if( $(tynt_class).length > 0 && !$(tag).hasClass(has_tynt) ){
                $(tag).addClass(has_tynt);
            }

            if( pos.top < triggerPoint ){

                $(tag).css({'left': 'auto'});
                $(tag).css({'margin-left': 'auto'});

                if( $(tag).hasClass(sticky) ){
                    $(tag).toggleClass(sticky);
                }

                if( $(tag).hasClass(slideUp) ){
                    $(tag).toggleClass(slideUp);
                }

            }else if( pos.width >= 768 && ( pos.top > triggerPoint && pos.top < hidePoint ) ){

                var mid_positon = (pos.alpha_width + pos.gamma_width - 688) / 2;
                //console.log(mid_positon);

                $(tag).css({'left': this.pos.gamma_left+'px'});
                $(tag).css({'margin-left': mid_positon+'px'});

                if( !$(tag).hasClass(sticky) ){
                    $(tag).toggleClass(sticky);
                }

                if( $(tag).hasClass(slideUp) ){
                    $(tag).toggleClass(slideUp);

                    $('li.top-left').addClass('skyscraper-ad');
                    $('li.top-right').addClass('skyscraper-ad');

                    $('.skyscraper-ad').css({'transform': 'translateY(0px)'});
                    this.ads.banner.adHidden = false;
                }

            }else if( pos.width >= 768 && pos.top >= hidePoint ){


                if( !$(tag).hasClass(slideUp) ){
                    $(tag).toggleClass(slideUp);

                    $('li.top-left').addClass('skyscraper-ad');
                    $('li.top-right').addClass('skyscraper-ad');

                    $('.skyscraper-ad').css({'transform': 'translateY(-650px)'});
                    this.ads.banner.adHidden = true;
                }

            }
        },

        /**
         * BOX TOP AD ON RIGHT COL NEEDS INITIAL SETUP
         * THIS TRIGGERS THE CODE NEEDED TO MAKE THE RIGHT COLUMN POSITIONING WORK
         */
        initBoxTop: function(){

            if( this.ads.box_top.init == false && this.pos.width >= 768 ) {

                var beta = this.ads.box_top.beta;

                $(beta).addClass('clearfix');
                this.ads.box_top.beta_top = $(beta).offset().top;
                this.ads.box_top.init = true;
            }
        },

        /**
         * ONCE INIT FOR BOX TOP RUNS THIS WILL UPDATE THE RIGHT COLUMN POSITIONING
         */
        parseBoxTop: function(){

            if(this.pos.width >= 768 && this.ads.box_top.init == true){

                this.activeAds.box_top = true;

                var theAd = this.ads.box_top.tag;
                var beta = this.ads.box_top.beta;
                var beta_top = this.ads.box_top.beta_top;

                var trigger = this.ads.box_top.trigger;
                var adHeight = this.ads.box_top.adHeight;

                var fixPos = this.ads.box_top.fixPos;
                // var absPos = this.ads.box_top.absPos;
                var relPos = this.ads.box_top.relPos;


                var triggerPoint = beta_top + trigger;

                var currentPoint = this.pos.top;
                //console.log(currentPoint+' < '+triggerPoint);

                if(currentPoint < beta_top){

                    $(beta).removeClass(fixPos);

                }else if( currentPoint >= beta_top ){

                    $(beta).addClass(fixPos);

                    if(currentPoint < triggerPoint){

                        $(beta).removeClass(relPos).css({'margin-top': 'initial'});

                    }else{

                        $(beta).addClass(relPos).css({'margin-top': trigger+'px'});

                    }

                }
            }
        },

        /**
         * BIG BANNER NEEDS INITIAL SETUP TO BECOME FIXED AT BOTTOM OF PAGE
         */
        initBigBanner: function(){

            if( this.pos.width >= 1400 ){

                var banner_big =  this.ads.banner_big;

                var adContainer = banner_big.adContainer;
                var adWrapper = banner_big.adWrapper;

                var adHeight = banner_big.adHeight;
                var ad = banner_big.ad;
                var $this = this;

                $(adContainer).wrapAll('<div class="'+adWrapper+'" />');

                $('.'+adWrapper).addClass('clearfix');

                $(ad).css({'transform': 'translateY('+adHeight+'px)'});

                //on clicking the corner X, slide the ad out and then display none so it doesn't appear again
                $('.'+adWrapper).on('click', '.banner-big-close', function(){
                    $this.activeAds.big_banner = false;

                    $(ad).css({'transform': 'translateY(600px)'});
                    createCookie('big_banner_manual_close', 'Clicked on big banner ad custom close x', 12, true);

                    setTimeout(function(){
                        $('.'+adWrapper).css({'display': 'none'});
                    }, 250);

                });

                // // Allow the code above to remove the image from the masthead
                // // But don't show the ad if the cookie exists
                var cookie = readCookie('big_banner_manual_close');
                if(cookie){

                    this.ads.banner_big.init = false;
                    $(this.ads.banner_big.ad).hide();
                    console.log('Big banner cookie found: '+cookie);
                    return;

                }else{

                    this.ads.banner_big.init = true;
                }
            }
        },

        /**
         * AFTER INIT FOR BIG BANNER THIS WILL UPDATE THE POSITIONING OF IT
         */
        parseBigBanner: function(){

            if(this.enabledAds.big_banner === true && this.ads.banner_big.init === true){

                this.activeAds.big_banner = true;

                var adHeight = this.ads.banner_big.adHeight;

                var alpha_left = this.pos.alpha_left + this.ads.banner_big.rightColPadding;

                var adWrapper = '.'+this.ads.banner_big.adWrapper;
                var adContainer = this.ads.banner_big.adContainer;
                var ad = this.ads.banner_big.ad;
                var hasCloser = this.ads.banner_big.hasCloser;

                //if the banner ad is disabled, check where it would normally be triggered
                //and update the adHidden value before checking if the big banner should show up
                if(this.enabledAds.banner == false){

                    // this.ads.banner.hidePoint
                    if(this.pos.top >= ( getBannerHidePoint() - window.innerHeight + $('#oracontainer').height() + 20 ) ){

                        this.ads.banner.adHidden = true;

                    }else{

                        this.ads.banner.adHidden = false;
                    }
                }

                //hide big banner if banner leaderboard is shown
                if(this.ads.banner.adHidden == false){

                    $(ad).css({'transform': 'translateY('+parseInt(adHeight+30)+'px)', 'visibility': 0});
                    $(adWrapper).css({'visibility': 'collapse'});

                    //$(adContainer).css({'visibility': 'collapse'});
                    $(adContainer).hide();

                    //show/hide big banner if leaderboard is hidden
                }else if(this.ads.banner.adHidden == true){

                    var top             = this.pos.top;
                    var hidePoint       = this.ads.banner_big.hidePoint;
                    var currentPoint    = top + window.innerHeight; //determines how far down to scroll the ad with the page

                    //show big banner
                    if(currentPoint < hidePoint){

                        if(hasCloser == false){
                            /*setTimeout(function(){
                $(ad).prepend('<div class="x-marks-the-spot banner-big-close "></div>');
              }, 2000);*/
                            $(adWrapper).prepend('<div class="x-marks-the-spot banner-big-close "></div>');
                            this.ads.banner_big.hasCloser = true;
                        }

                        $(ad).css({'transform': 'translateY(0px)','visibility': 'inherit', 'visibility': 'initial'});

                        //$(adContainer).css({'visibility': 'inherit', 'visibility': 'initial'});
                        $(adContainer).show();

                        $(adWrapper).css({'right': alpha_left+'px','visibility': 'inherit', 'visibility': 'initial'});

                        //hide big banner further down the page after hide point is passed
                    }else{

                        $(ad).css({'transform': 'translateY('+parseInt(adHeight+30)+'px)', 'visibility': 'collapse'});
                        $(adWrapper).css({'visibility': 'collapse'});

                        //$(adContainer).css({'visibility': 'collapse'});
                        $(adContainer).hide();
                    }
                }

            }
        },

        /**
         * MOBILE BOX TOP AD NEEDS INITIAL SETUP TO BE FIXED AT BOTTOM OF SCREEN
         */
        initMobileBoxTop: function(){

            if(this.ads.mobile_box_top.init == false && this.pos.width < 768){

                var cookie = readCookie('mobile_box_top');
                if(cookie){
                    console.log('Mobile box top cookie found: '+cookie);
                    $('.date-menu img').css({'padding-top': '20px'});
                    return;
                }

                $('.date-menu img').css({'padding-top': '10px !important'});

                if(!this.ads.mobile_box_top.adEl || this.ads.mobile_box_top.adEl == null){
                    this.ads.mobile_box_top.adEl = $('div.alpha div'+this.ads.mobile_box_top.tag);
                }

                var adHeight = this.ads.mobile_box_top.adHeight;
                var adWidth = this.ads.mobile_box_top.adWidth;

                if(!adHeight || adHeight == 0){
                    this.updateScrollValues();
                    adHeight = this.ads.mobile_box_top.adHeight;
                    adWidth = this.ads.mobile_box_top.adWidth;
                }
                console.log('adHeight: '+adHeight);
                console.log('adWidth: '+adWidth);

                var theAd = this.ads.mobile_box_top.tag;
                var wrapperTag = this.ads.mobile_box_top.wrapperTag;
                var containerTag = this.ads.mobile_box_top.containerTag;
                var adDiv = this.ads.mobile_box_top.adDiv;


                console.log(this.ads.mobile_box_top.adEl);
                $(this.ads.mobile_box_top.adEl).appendTo("body");

                $(this.ads.mobile_box_top.adEl).wrapAll('<div class="'+wrapperTag+'" />');
                $(this.ads.mobile_box_top.adEl).wrapAll('<div class="'+containerTag+'" />');
                $(this.ads.mobile_box_top.adEl).wrapAll('<div class="'+adDiv+'" />');
                console.log('wrappers');

                $('.'+wrapperTag).addClass('clearfix');
                $('.'+containerTag).addClass('clearfix');
                $('.'+adDiv).addClass('clearfix');

                $('.'+adDiv).prepend('<div class="x-marks-the-spot mobile-box-top-close "></div>');


                var margin_left = (this.pos.width - adWidth) / 2;
                $(this.ads.mobile_box_top.adEl).css({'margin-left': margin_left+'px'});

                this.updateScrollValues();

                this.ads.mobile_box_top.init = true;

                this.parseMobileBoxTop();

                //on clicking the corner X, slide the ad out and then display none so it doesn't appear again
                $('.'+wrapperTag).on('click', '.mobile-box-top-close', function(){

                    console.log('clicked');
                    $('.'+adDiv).css({'transform': 'translateY(300px)'});
                    createCookie('mobile_box_top', 'clicked on mobile ad close x', 1);

                    setTimeout(function(){
                        $('.'+wrapperTag).css({'display': 'none'});
                    }, 250);

                });
            }
        },

        /**
         * AFTER INIT FOR MOBILE BOX TOP THIS WILL REPOSITION IT
         */
        parseMobileBoxTop: function(){

            if(this.ads.mobile_box_top.init == true){

                this.activeAds.mobile_box_top = true;

                var adHeight = this.ads.mobile_box_top.adHeight;
                var adWidth = this.ads.mobile_box_top.adWidth;
                var hidePoint = this.ads.mobile_box_top.hidePoint;
                var adDiv = this.ads.mobile_box_top.adDiv;
                var wrapperTag = this.ads.mobile_box_top.wrapperTag;

                if(!adHeight || adHeight == 0){
                    this.updateScrollValues();
                    adHeight = this.ads.mobile_box_top.adHeight;
                }

                var margin_left = (this.pos.width - adWidth) / 2;
                $(this.ads.mobile_box_top.adEl).css({'margin-left': margin_left+'px'});

                if(this.pos.top < hidePoint){

                    $(wrapperTag).css({'visibility': 'inherit', 'visibility': 'initial'});
                    $('.'+adDiv).css({'transform': 'translateY(0px)', 'visibility': 'inherit', 'visibility': 'initial'});

                }else{

                    $(wrapperTag).css({'visibility': 'collapse'});
                    $('.'+adDiv).css({'transform': 'translateY(300px)', 'visibility': 'collapse'});
                }
            }
        },

    };
}

export default floatingAds;